import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";

function isServicePath(path) {
  return path.startsWith("/leistungen/");
}

export default function ScrollToTop() {
  const location = useLocation();
  const lenis = useLenis();
  const lenisRef = useRef(lenis);
  const prevPathRef = useRef(location.pathname);
  lenisRef.current = lenis;

  useEffect(() => {
    if (location.state?.scrollSpy) return;

    const { hash, pathname } = location;
    const prevPath = prevPathRef.current;
    prevPathRef.current = pathname;

    if (isServicePath(prevPath) && isServicePath(pathname) && prevPath !== pathname) {
      return;
    }

    const scroller = lenisRef.current;

    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        if (scroller) scroller.scrollTo(el, { offset: -72 });
        else el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }

    if (scroller) scroller.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, location.hash, location.key, location.state]);

  return null;
}
